export function type(a) {
    return Object.prototype.toString.call(a).slice(8, -1);
}
export function camelize(str) {
    const camelizeRE = /_(\w)/g;
    return str.replace(camelizeRE, toUpper);
}
export function trim(val) {
    return val ? (val + '').replace(/^\s+|\s+$/g, '') : '';
}
export function toUpper(_, c) {
    return c ? c.toUpperCase() : '';
}
export function noop() { }
const DCHN_LINK_REGEX = [
    /^(http(s?):\/\/)?((v(-hk)?\.)?didi\.cn|((m|x)\.)?huaxz\.cn)\/([A-Za-z])\//,
    /^(http(s?):\/\/)?((v(-hk)?\.)?didi\.cn|((m|x)\.)?huaxz\.cn)\//,
    /^(http(s?):\/\/)?v(-hk)?\.(udache\.com|xiaojukeji\.com)/,
    /^(http(s?):\/\/)?x\.(diditaxi\.com\.cn|kuaidadi\.com)/,
    /^(http(s?):\/\/)?es\.xiaojukeji\.com\/([A-Za-z])\//,
    /^(http:\/\/)?v-test.intra.xiaojukeji.com\/([A-Za-z]\/)?/,
    /^(http(s?):\/\/)?vstage-pre.intra.xiaojukeji.com\/([A-Za-z]\/)?/
];
export function getDchn(url) {
    let dchn = '';
    if (DCHN_LINK_REGEX.some(regex => regex.test(url))) {
        let splitUrl = url.split('/');
        let key = splitUrl[splitUrl.length - 1];
        dchn = key && key.indexOf('?') ? key.split('?')[0] : key;
    }
    return dchn;
}
export function checkWebxParams(params) {
    console.log('=== checkWebxParams === ', params);
    let { dchn, url, scene } = params;
    let noCompileDchn = params.extParams && params.extParams.noCompileDchn || false;
    let isWebx = false;
    if (noCompileDchn) {
        return {
            isWebx
        };
    }
    if (dchn || scene) {
        isWebx = true;
    }
    else if (url) {
        dchn = getDchn(url);
        isWebx = dchn ? true : false;
    }
    console.log({
        isWebx,
        doDchn: {
            dchn: dchn || '',
            url: url || '',
            scene: scene || ''
        }
    });
    return {
        isWebx,
        doDchn: {
            dchn: dchn || '',
            url: url || '',
            scene: scene || ''
        }
    };
}
function urlParams(obj) {
    let url = '';
    if (type(obj) === 'Object') {
        for (let k in obj) {
            let value = obj[k] !== undefined ? obj[k] : '';
            url += '&' + k + '=' + value;
        }
    }
    return url ? url.substring(1) : '';
}
export function buildUrl(url, params) {
    if (type(params) !== 'Object')
        return url;
    try {
        Object.keys(params).forEach(key => {
            const reg = new RegExp(`[\?&]${key}=[^&]*(?=(&|$))`); // eslint-disable-line
            if (url.match(reg)) {
                url = url.replace(reg, (s) => `${s[0]}${key}=${params[key]}`);
                delete params[key];
            }
        });
    }
    catch (err) {
        console.error(err);
    }
    const paramsStr = urlParams(params);
    let isHashParams = url.split('#')[1] ? (url.split('#')[1].indexOf('?') > -1) : (url.split('#')[0].indexOf('?') > -1);
    const separator = paramsStr
        ? isHashParams
            ? '&' : '?'
        : '';
    return `${url}${separator}${paramsStr}`;
}
// 处理 ? 后面的参数
export function handleParams(str) {
    if (!str) {
        return {};
    }
    const params = str.split('?')[1];
    const paramObj = params ? params.split('&') : [];
    const obj = {};
    paramObj.map(item => {
        const arr = item.split('=');
        obj[arr[0]] = arr[1];
    });
    return obj;
}
// 将参数对象转为 key=value 的格式
export function objToString(obj) {
    let str = '';
    const keys = Object.keys(obj);
    keys.forEach((key) => {
        str += `${str ? '&' : ''}${key}=${obj[key]}`;
    });
    return str;
}
